import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Firebase (Google Cloud)
import { auth } from '../../config/firebase-config';
import { signOut } from 'firebase/auth';

// Redux
import { connect } from 'react-redux';

// Actions
import { logout } from '../../actions/authActions';

const AuthDropdown = ({
    authDropdown, 
    setAuthDropdown,
    logout
}) => {

    const [processing, setProcessing] = useState(false);

    // Conditionally render scroll to top btn
    useEffect(() => {

        window.addEventListener('scroll', () => {
            setAuthDropdown(false);
        });
    }, []); 

    const handleLogout = async () => {
        setProcessing(true);
        try {
        
            // Sign out the user with firebase hook
            await signOut(auth);
    
            // Dispatch the LOGOUT action to clear the user data from the Redux store
            logout();
        } catch (err) {
            console.log('Error logging out', err);
        } finally {
            setProcessing(false);
        }
    }

    return (
        <Fragment>
            {/* Dropdown Menu */}
            <div className={authDropdown ? "profile-dropdown-topNavbar active" : "profile-dropdown-topNavbar"}>

            <div onClick={() => window.location = '/settings'} className="menu-item">
                Settings
            </div>

            <div onClick={() => window.location = '/help'} className="menu-item">
                Help
            </div>

            <div style={{height: '1px', width: '100%', backgroundColor: 'hsla(0,0%,100%,.1)'}} />
            
            <div onClick={!processing ? handleLogout : null} className="menu-item danger">
                {!processing ? 'Log Out' : 'Signing off...'}
            </div>
        </div>

        {/* Hidden Overlay for dropdown */}
        <div 
            className={`hidden-overlay ${authDropdown ? "show" : ""}`}
            onClick={() => setAuthDropdown(!authDropdown)}
        />
        </Fragment>
    )
}

AuthDropdown.propTypes = {
    // Prop type validation for authentication
    logout: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    // Mapping the authentication state
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    logout

})(AuthDropdown);